import axios from 'axios'
import Immutable from 'immutee'

import { getApiUrlSantander } from '../utils/utils'

export const FETCH_FINANCING_VERSIONS =
  'buyer/proposal/FETCH_FINANCING_VERSIONS'
export const FETCH_FINANCING_VERSIONS_FAILURE =
  'buyer/proposal/FETCH_FINANCING_VERSIONS_FAILURE'

const initialState = {
  fetched: false,
  result: [],
  error: null,
}

export default function reducer(state = initialState, action) {
  const immutable = Immutable(state)
  switch (action.type) {
    case FETCH_FINANCING_VERSIONS:
      return immutable.set('result', action.payload).set('fetched', true).done()

    case FETCH_FINANCING_VERSIONS_FAILURE:
      return immutable
        .set('error', action.payload.stack)
        .set('errorID', action.payload.statusCode)
        .set('result', [])
        .set('fetched', false)
        .done()

    default:
      return state
  }
}

export function fetchFinancingVersions(idMakes) {
  const _url = `${getApiUrlSantander()}financiamento/ano-combustivel?id=${idMakes}`
  return dispatch => {
    return axios
      .get(_url)
      .then(res => {
        dispatch({
          type: FETCH_FINANCING_VERSIONS,
          payload: res.data.Result,
        })
      })
      .catch(err => {
        dispatch({
          type: FETCH_FINANCING_VERSIONS_FAILURE,
          payload: {
            stack:
              err.response.data.Messages.length > 0
                ? err.response.data.Messages[0]
                : err.stack,
            statusCode: err.response.data.StatusCode,
          },
        })
      })
  }
}
